import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterMeanType } from './z-printer-mean-type';

@MappedClass()
export class ZPrinterMeanTypeApplicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedProperty()
  value: ZPrinterMeanType;
}
